import { useContext } from 'react';
import { AnalyticsContext } from '../../../ModularReduxAnalytics';

import ProvePrefill from './index';

const ProvePrefillContainer = props => {
  const { analytics, segment } = useContext(AnalyticsContext);

  const childProps = {
    ...props,
    analytics,
    segment
  };

  return <ProvePrefill {...childProps} />;
};

export default ProvePrefillContainer;
